<template>
  <div>
    <button :aria-expanded="isOpen" @click="toggleAccordion()">
      <slot name="title" />
      <svg
        class="p-l-10"
        :class="{
          'rotate-90': isOpen,
          'rotate-0': !isOpen
        }"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 10"
        aria-hidden="true"
        width="12"
        height="10"
      >
        <path d="M15 1.2l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <div v-if="isOpen" class="accordion-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppAccordion",
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
<style scoped lang="scss">
button {
  background: #fff;
  border: none;
}
.rotate-90 {
  transform: rotate(-90deg);
  vertical-align: bottom;
}
</style>
